import { render, staticRenderFns } from "./InventoryByUser.vue?vue&type=template&id=1ee21ff4&scoped=true&"
import script from "./InventoryByUser.vue?vue&type=script&lang=js&"
export * from "./InventoryByUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee21ff4",
  null
  
)

export default component.exports